import { render, staticRenderFns } from "./PlaceWorkersDialog.vue?vue&type=template&id=25382b5a&"
import script from "./PlaceWorkersDialog.vue?vue&type=script&lang=js&"
export * from "./PlaceWorkersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports